import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CombineXyzSockets} from "#material/nodes/converter/combine-xyz/definition"
import {combineXyzDefinition} from "#material/nodes/converter/combine-xyz/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeValue} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {ThreeTsl as TSL} from "#material/three/exports"
import type {ThreeReturns} from "#material/sockets/three"
import type {CombineXyzNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class CombineXyz extends MaterialNode<CombineXyzSockets> {
    public override get definition() {
        return combineXyzDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<CombineXyzSockets>> => {
        const {x, y, z} = await evaluator.getAll({
            x: this.parameters.inputs.x,
            y: this.parameters.inputs.y,
            z: this.parameters.inputs.z,
        })
        const xValue = x?.toFloat() ?? threeValue(this.parameters.settings.x ?? 0)
        const yValue = y?.toFloat() ?? threeValue(this.parameters.settings.y ?? 0)
        const zValue = z?.toFloat() ?? threeValue(this.parameters.settings.z ?? 0)
        return {vector: TSL.vec3(xValue, yValue, zValue)}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<CombineXyzSockets>> => {
        const combineXyzNode: CombineXyzNode = {
            type: "combine_xyz",
            inputs: await evaluator.getAll({
                x: this.parameters.inputs.x,
                y: this.parameters.inputs.y,
                z: this.parameters.inputs.z,
            }),
            parameters: {
                x: this.parameters.settings.x,
                y: this.parameters.settings.y,
                z: this.parameters.settings.z,
            },
            resources: {},
        }

        return {vector: [combineXyzNode, "vector"]}
    }
}
